import React from 'react';
import PropTypes from 'prop-types';
import Amount from "components/Display/Amount";

import TransactionKey from "../Display/TransactionKey";


class ReturnResultTable extends React.Component {

  constructor(props){
    super(props);
  }

  render() {
    if (!this.props.data.returns){
      return (
        <div/>
      );
    }

    let returns = this.props.data.returns;
    return (
      <div className="calc-setting-table">
        <table className="table">
          <colgroup>
            <col />
            <col />
          </colgroup>
          <thead>
          <tr>
            <th colSpan="2" className="text-left">
              <span className="calc-setting-table-header">Útreiknuð skil miðað við innborganir</span>
            </th>
          </tr>
          <tr>
            <th className="text-left">Færslulykill</th>
            <th className="text-right">Staða</th>
          </tr>
          </thead>
          <tbody>
          {returns.map((item,i) => {
            return(
              <tr key={i}>
                <td className="text-left"> <TransactionKey data={item.transactionKey}/></td>
                <td className="text-right"><Amount data={item.amount}/></td>
              </tr>)
          })}
          </tbody>
        </table>
      </div>
    );
  }
}

ReturnResultTable.propTypes = {
  data: PropTypes.object,
};



export default ReturnResultTable;



// WEBPACK FOOTER //
// ./src/pages/Calculation/Results/ReturnResultTable.js